import React, { useMemo } from "react";
import EdiText from "react-editext";
import { updateUser } from "../../services/api";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";

const EditableEmailCell = ({ value, setNameModal, setUserIds, rowData, toast, userId, onSuccess, canEdit = true }) => {
    const [error, setError] = React.useState("");
    const dispatch = useDispatch()
    const adminData = useSelector(state => state.adminAuth.adminSessionData);
    const headers = useMemo(() => {
        return { sessionid: adminData.sessionId };
    }, [adminData.sessionId]);
    const [inputValue, setInputValue] = React.useState(value || "-");
    const [originalValue, setOriginalValue] = React.useState(value || "-");

    React.useEffect(() => {
        setInputValue(value || "-");
        setOriginalValue(value || "-");
    }, [value]);

    const validate = (val) => {
        const trimmed = val.trim();

        if (!trimmed) {
            setError("Email is required");
            return false;
        }

        // Simple email regex
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(trimmed)) {
            setError("Invalid email format");
            return false;
        }

        setError("");
        return true;
    };

    const handleEditClick = (e) => {
        setUserIds({ userId: rowData?.userId, rowData: rowData, to: rowData?.email })
        if (setNameModal) setNameModal(true)
    };

    if (!canEdit) {
        return <div className="column-data user-edit">{inputValue}</div>;
    }

    return (
        <div className="column-data user-edit">
            <EdiText
                type="text"
                value={inputValue}
                onSave={(val) => {
                    if (validate(val)) {
                        const obj = {
                            userId: userId || rowData?.userId,
                            email: val,
                        };
                        updateUser(obj, headers, dispatch, response => {
                            if (response.result === 'SUCCESS') {
                                setInputValue(val);
                                setOriginalValue(val);
                                if (onSuccess) onSuccess();
                                toast.current?.show({ severity: 'success', summary: 'Success', detail: "Customer email updated successfully." })
                            } else {
                                const error = response.error;
                                toast.current?.show({ severity: error.severity, summary: 'Error', detail: (error.errorMsg) ? error.errorMsg : error.summary })
                            }
                        });
                    }
                }}
                onCancel={() => {
                    setInputValue(originalValue);
                    setError("");
                }}
                saveButtonClassName={`nameedit-btn save ${error ? "disabled" : ""}`}
                editButtonClassName="nameedit-btn edit"
                cancelButtonClassName="nameedit-btn cancel"
                saveButtonContent={<i className="pi pi-check" />}
                editButtonContent={
                    process.env.REACT_APP_NAME === "esimcrew" && !setNameModal ? (
                        <span
                            className="nameedit-btn edit"
                            onClick={(e) => {
                                e.stopPropagation(); // prevent EdiText from triggering directly
                                handleEditClick();
                            }}
                        >
                            <i className="pi pi-pencil" />
                        </span>
                    ) : (
                        <i className="pi pi-pencil" />
                    )
                }
                cancelButtonContent={<i className="pi pi-times" />}
                viewContainerClassName="custom-view-container"
                editContainerClassName="custom-edit-container"
                inputProps={{
                    value: inputValue,
                    onChange: (e) => {
                        setInputValue(e.target.value);
                        validate(e.target.value);
                    },
                    onBlur: (e) => validate(e.target.value),
                }}
            />
            {error && (
                <span className="customers-error">
                    {error}
                </span>
            )}
            <style>
                {`
            .nameedit-btn.save.disabled {
            opacity: 0.5;
            pointer-events: none;
            }
        `}
            </style>
        </div>
    );
};

export default EditableEmailCell;
